import { emitServices } from "./emitServices";
import { Services } from "@/types/serviceTypes";

export const toggleSelectedService = (
  serviceId: string,
  services: Services,
) => {
  const newServices: Services = [];

  for (const service of services) {
    if (service.id === serviceId) {
      newServices.push({ ...service, selected: !service.selected });
    } else {
      newServices.push(service);
    }
  }
  const selectedServices = newServices.filter((service) => service.selected);

  emitServices(selectedServices);
  return newServices;
};
